const isBitSet=(num, bitPosition)=> {
    return (num & (1 << (bitPosition - 1))) !== 0;
}

export {isBitSet}